<router-outlet></router-outlet>

<!--
<app-global-template></app-global-template>
-->